import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function ThemedHybridFlowerTypeIndicator(props) {
  const config = useThemeConfig();
  const ThemedHybridFlowerTypeIndicator = config.components.HybridTypeIndicator;

  return <ThemedHybridFlowerTypeIndicator {...props} />;
}
